module.exports = __webpack_public_path__ + "media/images/note-9d7118a9.svg";